module.exports = __webpack_public_path__ + "static/media/iStock-905835162.d8d31351.jpg";